import { Routes, Route, Navigate } from 'react-router-dom'
import useTheme from './hooks/useTheme'
import { AuthProvider } from './context/AuthProvider'
import { DataElementsProvider } from './context/DataElementsProvider'
import { ToastContext } from './context/ToastContext'
import useToast from './hooks/useToast'

import { ProtectedRoute } from '@/routes/ProtectedRoute'
import { PublicRoute } from './routes/PublicRoute'

import Layout from './layouts/Layout'
import LoginPage from './pages/LoginPage'
import NotFoundPage from './pages/NotFoundPage'
import ToastMini from './components/ToastMini'
import SubmittalsListingPage from './pages/Submittals/SubmittalsListingPage'
import { SubmittalDetailPage } from './pages/Submittals/SubmittalDetailPage'

export default function App() {
  useTheme()
  const toast = useToast()

  return (
    <AuthProvider>
      <DataElementsProvider>
        <ToastContext.Provider value={toast}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Public */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />

            {/* Protected */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/submittals">
                  <Route index element={<SubmittalsListingPage />} />
                  <Route path=":submittalId" element={<SubmittalDetailPage />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <ToastMini />
        </ToastContext.Provider>
      </DataElementsProvider>
    </AuthProvider>
  )
}
